(function () {
  var grid = document.querySelector('#product-grid ul.product-grid');
  if (!grid) return;

  var params = new URLSearchParams(window.location.search);
  var q = params.get('q');
  if (!q) return;

  var noResultsEl = document.getElementById('search-no-results-msg');
  var originalNoResultsHTML = noResultsEl ? noResultsEl.innerHTML : null;
  if (noResultsEl) {
    noResultsEl.innerHTML = 'No results were found in our local collections, please wait while we perform a deep search&hellip;';
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function titleToHandle(title) {
    return title
      .toLowerCase()
      .replace(/['‘’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function buildCard(book) {
    var handle = titleToHandle(book.title);
    var price  = book.price != null ? '$' + Number(book.price).toFixed(2) + ' AUD' : '';
    var img    = (book.image && /^https:\/\//.test(book.image))
      ? '<img src="' + esc(book.image) + '" alt="' + esc(book.title) + '" loading="lazy" class="motion-reduce" width="300" height="375">'
      : '';

    return '<li class="grid__item extended-search-result">'
      + '<div class="card-wrapper product-card-wrapper underline-links-hover">'
      + '<div class="card card--card card--media color-scheme-2 gradient" style="--ratio-percent:125%;">'
      + '<div class="card__inner ratio" style="--ratio-percent:125%;">'
      + '<div class="card__media"><div class="media media--transparent media--hover-effect">' + img + '</div></div>'
      + '<div class="card__content"><div class="card__information"><h3 class="card__heading"><a href="/products/' + handle + '" class="full-unstyled-link">' + esc(book.title) + '</a></h3></div></div>'
      + '</div>'
      + '<div class="card__content"><div class="card__information">'
      + '<h3 class="card__heading h5"><a href="/products/' + handle + '" class="full-unstyled-link">' + esc(book.title) + '</a></h3>'
      + '<div class="card-information">'
      + (book.author ? '<span class="visually-hidden">Vendor</span><div class="caption-with-letter-spacing light">' + esc(book.author) + '</div>' : '')
      + (price ? '<div class="price"><div class="price__container"><div class="price__regular"><span class="price-item price-item--regular">' + price + '</span></div></div></div>' : '')
      + '</div>'
      + '</div></div>'
      + '</div></div>'
      + '</li>';
  }

  function getModal() {
    var existing = document.getElementById('baloo-redirect-overlay');
    if (existing) return existing;
    var el = document.createElement('div');
    el.id = 'baloo-redirect-overlay';
    el.innerHTML = '<div class="baloo-redirect-modal">'
      + '<p>Please wait while we redirect you to the book&hellip;</p>'
      + '<div class="baloo-redirect-spinner"></div>'
      + '</div>';
    document.body.appendChild(el);
    return el;
  }

  function showModal() { getModal().classList.add('baloo-redirect-overlay--active'); }
  function hideModal() { getModal().classList.remove('baloo-redirect-overlay--active'); }

  function pollAndRedirect(url) {
    showModal();
    var attempts = 0;
    var max = 20;

    function check() {
      fetch(url, { method: 'HEAD' })
        .then(function (r) {
          if (r.ok) {
            window.location.href = url;
          } else if (++attempts < max) {
            setTimeout(check, 1500);
          } else {
            hideModal();
            window.location.href = url;
          }
        })
        .catch(function () {
          if (++attempts < max) {
            setTimeout(check, 1500);
          } else {
            hideModal();
            window.location.href = url;
          }
        });
    }

    check();
  }

  grid.addEventListener('click', function (e) {
    var link = e.target.closest('.extended-search-result a');
    if (!link) return;
    e.preventDefault();
    pollAndRedirect(link.href);
  });

  fetch('/apps/baloo/extendedsearch/search?q=' + encodeURIComponent(q) + '&limit=5')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var results = data.results || [];

      if (!results.length) {
        if (noResultsEl && originalNoResultsHTML !== null) {
          noResultsEl.innerHTML = originalNoResultsHTML;
        }
        return;
      }

      if (noResultsEl) {
        noResultsEl.innerHTML = 'We found ' + results.length + ' result'
          + (results.length !== 1 ? 's' : '') + ' in our deep collection.';
      }

      results.slice().reverse().forEach(function (book) {
        grid.insertAdjacentHTML('afterbegin', buildCard(book));
      });
    })
    .catch(function () {
      if (noResultsEl && originalNoResultsHTML !== null) {
        noResultsEl.innerHTML = originalNoResultsHTML;
      }
    });
})();
